function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 8,
  width: 24,
  height: 16,
  rx: 3,
  stroke: "#2DB35C",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 12.71v6.58a1 1 0 001.49.872l5.85-3.29a1 1 0 000-1.744l-5.85-3.29a1 1 0 00-1.49.872z",
  fill: "#2DB35C"
});

var SvgIconCodetypeVideo = function SvgIconCodetypeVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSI0IiB5PSI4IiB3aWR0aD0iMjQiIGhlaWdodD0iMTYiIHJ4PSIzIiBzdHJva2U9IiMyREIzNUMiIHN0cm9rZS13aWR0aD0iMiIvPgogIDxwYXRoIGQ9Ik0xMi45OTk4IDEyLjcwOThWMTkuMjkwMkMxMi45OTk4IDIwLjA1NSAxMy44MjM0IDIwLjUzNjcgMTQuNDkgMjAuMTYxN0wyMC4zMzkyIDE2Ljg3MTZDMjEuMDE4OSAxNi40ODkzIDIxLjAxODkgMTUuNTEwNyAyMC4zMzkyIDE1LjEyODRMMTQuNDkgMTEuODM4M0MxMy44MjM0IDExLjQ2MzMgMTIuOTk5OCAxMS45NDUgMTIuOTk5OCAxMi43MDk4WiIgZmlsbD0iIzJEQjM1QyIvPgo8L3N2Zz4K";
export { SvgIconCodetypeVideo as ReactComponent };